if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
            this.removeListSemantic();
        }

        // OKB: Arrow key navigation through gallery slides
        this.boundGalleryKeydown = this.handleGalleryKeydown.bind(this);
        document.addEventListener('keydown', this.boundGalleryKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.boundGalleryKeydown);
      }

      // OKB: Navigate gallery with ArrowLeft / ArrowRight keys
      handleGalleryKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        // Bail out for text-entry inputs, textareas, and selects — they need arrow keys
        // But let radio/checkbox (variant pills) fall through: we intercept and blur them
        // so gallery navigation always wins over native radio cycling
        const el = document.activeElement;
        if (el) {
          const tag = el.tagName;
          const type = (el.type || '').toLowerCase();
          if (tag === 'TEXTAREA' || tag === 'SELECT') return;
          if (tag === 'INPUT' && type !== 'radio' && type !== 'checkbox') return;
          // Variant pill has focus — release it so subsequent arrows also go to gallery
          if (tag === 'INPUT') el.blur();
        }

        // Don't intercept while the lightbox is open
        const lightbox = document.getElementById('product-image-lightbox');
        if (lightbox && lightbox.getAttribute('aria-hidden') === 'false') return;

        const visibleSlides = Array.from(this.querySelectorAll('.product__media-item:not([hidden])'));
        if (visibleSlides.length < 2) return;

        const activeSlide = this.querySelector('.product__media-item.is-active');
        const currentIndex = activeSlide ? visibleSlides.indexOf(activeSlide) : 0;

        const nextIndex = event.key === 'ArrowLeft'
          ? (currentIndex > 0 ? currentIndex - 1 : visibleSlides.length - 1)
          : (currentIndex < visibleSlides.length - 1 ? currentIndex + 1 : 0);

        const target = visibleSlides[nextIndex];
        if (target?.dataset?.mediaId) {
          event.preventDefault();
          this.setActiveMedia(target.dataset.mediaId, false);
        }
      }

      // This is now a proper method of the class
      filterByColor(color) {
        // *** START: NUCLEAR FIX FOR GIFT CARD ***
        // Prevents all filtering on the Gift Card product page
        if (window.location.pathname.includes('/products/the-ok-digital-gift-card')) {
             // We still need to ensure the main image doesn't show 'display: none'
             // (This should already be fixed by the custom-script, but this is a final layer)
             this.querySelectorAll('.product__media-item').forEach(item => {
                 item.classList.remove('media-hidden');
                 item.removeAttribute('hidden');
                 item.style.removeProperty('display');
             });
             // Skip the rest of the filtering logic
             return; 
        }
        // *** END: NUCLEAR FIX FOR GIFT CARD ***

        if (!color) return;
        
        const HIDE_CLASS = 'media-hidden';
        const mainMediaItems = this.querySelectorAll('.product__media-item');
        const thumbMediaItems = this.querySelectorAll('.thumbnail-list__item');

        // Hide or show main images and thumbnails based on the selected color
        mainMediaItems.forEach(item => {
            const itemColor = item.dataset.color || '';
            const isMatch = (itemColor.toLowerCase() === color.toLowerCase()) || (itemColor.trim() === '');
            item.classList.toggle(HIDE_CLASS, !isMatch);
            item.toggleAttribute('hidden', !isMatch); // Also toggle hidden attribute for accessibility and for PhotoSwipe
        });

        thumbMediaItems.forEach(item => {
            const itemColor = item.dataset.color || '';
            const isMatch = (itemColor.toLowerCase() === color.toLowerCase()) || (itemColor.trim() === '');
            item.classList.toggle(HIDE_CLASS, !isMatch);
            item.toggleAttribute('hidden', !isMatch);
        });

        // --- START: FINAL FIX ---
    // After filtering, find the first VISIBLE thumbnail and make its
    // corresponding main image active. This fixes the blank image issue.
    const firstVisibleThumbnail = this.querySelector('.thumbnail-list__item:not(.media-hidden)');
    if (firstVisibleThumbnail) {
      this.setActiveMedia(firstVisibleThumbnail.dataset.target, false);
    }
    // --- END: FINAL FIX ---

        // Use a short delay to allow the DOM to update before resetting the sliders
        setTimeout(() => {
      if (this.elements.viewer && typeof this.elements.viewer.slider?.resetPages === 'function') {
          this.elements.viewer.slider.resetPages();
      }
      if (this.elements.thumbnails && typeof this.elements.thumbnails.slider?.resetPages === 'function') {
          this.elements.thumbnails.slider.resetPages();
      }
      
      // ADD THIS LINE: Announce that the filtering and resetting is truly complete.
      this.dispatchEvent(new CustomEvent('filter:complete', { bubbles: true }));

    }, 50);
      }

      onSlideChanged(event) {
        if (!event.detail.currentElement || !event.detail.currentElement.dataset) {
          console.warn('MediaGallery: Missing event.detail.currentElement or its dataset in onSlideChanged.', event);
          return;
        }
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
  const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
  if (!activeMedia) return;

  this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
    element.classList.remove('is-active');
  });
  activeMedia.classList.add('is-active');

// ** START: FINAL JS HEIGHT OVERRIDE (v5) **
  const isAdaptive = activeMedia.querySelector('.product-media-container.media--autoheight');
  if (isAdaptive) {
    // 1. Force the slide itself (LI) to auto-size
    activeMedia.style.height = 'auto';
    activeMedia.style.minHeight = 'unset';
    activeMedia.style.maxHeight = 'unset'; // Aggressively reset max-height
    // 2. Force the immediate wrapper (UL) to auto-size
    activeMedia.parentElement.style.height = 'auto';
    activeMedia.parentElement.style.minHeight = 'unset';
    activeMedia.parentElement.style.maxHeight = 'unset';
    // 3. Force the slider component (Custom Element) to auto-size
    this.elements.viewer.style.height = 'auto';
    this.elements.viewer.style.minHeight = 'unset';
    this.elements.viewer.style.maxHeight = 'unset';
    // 4. Force the media-gallery wrapper (this element) to auto-size
    this.style.height = 'auto';
    this.style.minHeight = 'unset';
    this.style.maxHeight = 'unset';
  }
  // ** END: FINAL JS HEIGHT OVERRIDE **

  // --- START: OKB MODIFICATION for smooth fade transition ---
  activeMedia.classList.add('is-loading');
  const image = activeMedia.querySelector('img');

  if (image) {
    if (image.complete) {
      // If the image is already in the cache, it's loaded instantly.
      activeMedia.classList.remove('is-loading');
    } else {
      // Otherwise, wait for it to load completely.
      image.onload = () => {
        activeMedia.classList.remove('is-loading');
      };
    }
  } else {
    // If the media item is a video or 3D model, not an image, remove the class immediately.
    activeMedia.classList.remove('is-loading');
  }
  // --- END: OKB MODIFICATION ---

  if (prepend) {
    if (activeMedia.parentElement.firstChild !== activeMedia) {
      activeMedia.parentElement.prepend(activeMedia);
    }
    if (this.elements.thumbnails) {
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
        activeThumbnail.parentElement.prepend(activeThumbnail);
      }
    }
    if (this.elements.viewer.slider) this.elements.viewer.resetPages();
  }

  this.preventStickyHeader();
  window.setTimeout(() => {
    if (this.mql.matches && this.elements.thumbnails) {
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail) {
        this.elements.thumbnails.slider.scrollTo({ left: activeThumbnail.offsetLeft });
      }
    } else {
      activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
    }
    const activeMediaRect = activeMedia.getBoundingClientRect();
    if (activeMediaRect.top > -0.5) return;
    const top = activeMediaRect.top + window.scrollY;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
  this.playActiveMedia(activeMedia);

  if (!this.elements.thumbnails) return;
  const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
  this.setActiveThumbnail(activeThumbnail);
  this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
}

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        
        if (this.elements.thumbnails.isSlideVisible && !this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
           this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        
        const announce = () => {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(() => {
                this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
        };

        if (image.complete) {
            announce();
        } else {
            image.onload = announce;
        }
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.slider.querySelectorAll('li').forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
